import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CurrentUser } from "../../common/providers/current-user";
import { EvaluationAthleteProvider } from '../../evaluation-athlete/providers/evaluation-athlete-provider.services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfigProvider } from "../../config-provider.service";
import { Title } from '@angular/platform-browser';
import { SimpleMatDataSource } from '../../common/providers/simple-mat-data-source';
import {
  MobileModuleContentComponent,
  ModuleMenu
} from "../../common/components/mobile-module-content/mobile-module-content";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { map, Observable, Subscription } from 'rxjs';
import { Error404Component } from "../../common/components/error-404/error-404";
import { Error401Component } from "../../common/components/error-401/error-401";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MatChipsModule } from "@angular/material/chips";
import { MatTableModule } from "@angular/material/table";
import { NgClass, NgIf } from "@angular/common";
import { AppDatePipe } from "../../common/pipes/app-date";
import { Organization } from "../../common/models/organization";
import { Evaluation } from "../../common/models/evaluation";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";
import { User } from "../../common/models/user";
import { Paginator } from "../../common/models/paginator";

@Component({
  selector: 'app-mobile-evaluation-list',
  templateUrl: './mobile.evaluation.list.component.html',
  styleUrls: ['./mobile.evaluation.list.component.scss'],
  imports: [
    MobileModuleContentComponent,
    MatPaginator,
    Error404Component,
    Error401Component,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    MobilePageContentComponent,
    MatChipsModule,
    MatTableModule,
    NgIf,
    RouterLink,
    TranslateModule,
    NgClass,
    AppDatePipe,
  ],
  standalone: true
})
export class MobileEvaluationListComponent implements OnInit, AfterViewInit, OnDestroy {

  public pageTitle = 'EvaluationAthleteList';
  public isLoading = true;
  public is401 = false;
  public is404 = false;

  public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
  public columns: string[] = ['name', 'date', 'status'];

  public organization: Organization = {} as Organization;
  public athleteUser: User = {} as User;
  public evaluations: Evaluation[] = [];

  public paginatedResults: Paginator | undefined;
  public pageSize: number = EvaluationAthlete.NUM_ITEMS;
  public currentPage = 0;
  public totalSize = 0;
  public mainActions: ModuleMenu[] = [];

  @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

  private subscriptions: Subscription[] = [];

  constructor(
    public conf: ConfigProvider,
    private title: Title,
    private currentUser: CurrentUser,
    private translater: TranslateService,
    private route: ActivatedRoute,
    private evaluationAthleteProvider: EvaluationAthleteProvider,
    private utils: UtilsProvider,
  ) {
  }

  public ngOnInit() {
    this.subscriptions.push(
      this.route.data.subscribe((data: any) => {//{ organization: Organization; athlete: Athlete }
        this.organization = data.organization;
        this.athleteUser = data.athlete;
        this.loadPaginatedData().subscribe(() => {
          this.createPageTitle();
          this.isLoading = false;
        });
      })
    );
  }

  public ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator!;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public loadPaginatedData(page = 0, query = ''): Observable<any> {
    return this.evaluationAthleteProvider.getByAthletePaginated(this.organization, this.athleteUser.athlete!, page).pipe(
      map((paginator: Paginator) => {
          this.paginatedResults = paginator;
          this.currentPage = this.paginatedResults.current_page - 1;
          this.pageSize = this.paginatedResults.per_page;
          this.totalSize = this.paginatedResults.total;

          this.dataSource.replaceAllWith(this.paginatedResults.data);

          this.evaluations = this.paginatedResults.data.map((evaluationAthlete: EvaluationAthlete) => evaluationAthlete.evaluation!);
      })
    );
  }

  public onPaginateChange(event: PageEvent) {
    this.loadPaginatedData(event.pageIndex + 1).subscribe();
  }

  private createPageTitle() {
    this.pageTitle = this.translater.instant('EvaluationOfAthlete', { athlete: this.currentUser.user?.firstName + ' ' + this.currentUser.user?.lastName });
    this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
  }
}
